export default "__VITE_ASSET__D8AIsr46__"